export default __webpack_public_path__ + "static/img-1-1470491652f0d6757b0554096ca10e69.jpg";